import { NON_US_REGION, US_REGION } from '../../ui/app-legal-regions';
import { createUser } from '../models/user';

const userMapper = {
    toDomain(userData) {
        return createUser({
            id: userData.id,
            email: userData.email,
            onboarding: userData.onboarding,
            firstName: userData.firstName,
            isActiveSubscription: userData.subscriptionFeatures.includes('websiteExtended') || userData.subscriptionFeatures.includes('memoryKeeper'),
            subscriptionFeatures: userData.subscriptionFeatures,
            legalRegion: userData.countryCode === US_REGION ? US_REGION : NON_US_REGION,
            isAuthenticated: true
        });
    }
};

export {
    userMapper
};
